import { render, staticRenderFns } from "./ProfileModal.vue?vue&type=template&id=0869b9cb&scoped=true&"
import script from "./ProfileModal.vue?vue&type=script&lang=ts&"
export * from "./ProfileModal.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileModal.vue?vue&type=style&index=0&id=0869b9cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0869b9cb",
  null
  
)

export default component.exports